@if (data$ | async; as data) {
	@if (!!buttons && !actionInProgress()) {
		<div class="button-bar">
			<div class="buttons">
				<div class="buttons">
					@for (button of buttons; track button) {
						@if ($any(button).visible()) {
							<button
								(click)="button.click()"
								[class]="button.class"
								[translate]="button.translate"
								[disabled]="$any(button).disabled()"
							></button>
						}
					}
				</div>
			</div>
		</div>
	}
	<ng-template #list>
		@if (isSelectDeselectButtonsEnabled()) {
			<ng-container *ngTemplateOutlet="selectDeselectAllButtonTemplate" />
		}
		@if (informationTemplate) {
			<div class="information no-border">
				<ng-container *ngTemplateOutlet="informationTemplate; context: { $implicit: data }"></ng-container>
			</div>
		}
		<ul [class]="listStyles">
			@if (listHeaderTemplate) {
				<li class="list-item">
					<ng-container *ngTemplateOutlet="listHeaderTemplate; context: { $implicit: data }"></ng-container>
				</li>
			}
			@if (mode === Mode.ADD) {
				<li class="relative list-item add-item">
					<div class="fullsize">
						@if (!autoCompleteTemplate) {
							<stages-add
								#addComponent
								[focusOnInit]="true"
								[placeholder]="getSearchPlaceHolder() | translate"
								[maxLength]="addMaxLength()"
								[pattern]="addPattern()"
								[patternMessageKey]="addPatternMessageKey()"
								(submitted)="add($event)"
								(focusLost)="cancelAdd()"
								(cancelled)="cancelAdd()"
								class="relative"
							>
							</stages-add>
						}
						@if (autoCompleteTemplate) {
							<stages-auto-complete-search
								#autoComplete
								[focusOnInit]="true"
								[placeholder]="getSearchPlaceHolder() | translate"
								[query]="dataSource.newSearchQuery()"
								(submitted)="add($event)"
								(cancelled)="cancelAdd()"
								(focusLost)="cancelAdd()"
								[searchResultTemplate]="autoCompleteTemplate"
								[browseButtonActive]="browseItemButtonActive"
								(openBrowserButtonPressed)="openButtonPressed()"
								(closeButtonPressed)="closeButtonPressed()"
								class="relative"
							>
							</stages-auto-complete-search>
							@if (autoCompleteBrowseTemplate) {
								<p [class]="autoCompleteBrowseTemplatePragraphStyles">
									<ng-container *ngTemplateOutlet="autoCompleteBrowseTemplate"></ng-container>
								</p>
							}
						}
					</div>
				</li>
			}
			@if (searchEngineAvailable || !hasActiveFilters()) {
				@for (item of data.items; track trackBy($index, item)) {
					<li class="list-item" [ngClass]="getClasses(item)" [class.disabled]="inactiveFn()(item)">
						@if (selectable) {
							<div class="select">
								<input
									type="checkbox"
									class="checkbox"
									[id]="'select' + idFn(item)"
									[name]="'select' + idFn(item)"
									[checked]="
										(!idFnNew() && selection.isSelected(idFn(item))) ||
										(item
											| selectionStoreIsSelected
												: storeIdentifier()
												: isSelectAllActivated
												: triggerChangeCounter
												: idFnNew()
												: isPreselectedFn())
									"
									(change)="toggleSelection(item)"
									[disabled]="disabledFn()(item, data, mode)"
									[indeterminate]="
										item
											| selectionStoreIsPartiallySelected: storeIdentifier() : triggerChangeCounter : false : idFnNew()
									"
								/>
								<label [for]="'select' + idFn(item)"></label>
							</div>
						}
						<ng-container *ngTemplateOutlet="listItemTemplate!; context: { $implicit: item }"></ng-container>
					</li>
				}
				@if (data.page < data.totalPageCount && showMore()) {
					<li class="list-item">
						<a class="label clickable" (click)="dataSource.loadMore()">
							<div class="avatar-cell-48"></div>
							<div class="text center">
								<span class="show-more" translate="more"></span>
							</div>
						</a>
					</li>
				}
				@if (!!translateNone && data.totalItemCount === 0) {
					<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: translateNone }"></ng-container>
				}
			}
			@if (!searchEngineAvailable && hasActiveFilters()) {
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: 'search.notavailable' }"></ng-container>
			}
		</ul>
		@if (isSelectAllEnabled()) {
			<li class="list-item">
				<ng-container *ngTemplateOutlet="selectAllTemplate"></ng-container>
			</li>
		}
	</ng-template>
	<ng-template #table>
		@if (informationTemplate) {
			<div class="information no-border">
				<ng-container *ngTemplateOutlet="informationTemplate; context: { $implicit: data }"></ng-container>
			</div>
		}
		@if (searchEngineAvailable || !hasActiveFilters()) {
			<table class="table center" #coreTable>
				@if (headerTemplate && !(!!translateNone && data.totalItemCount === 0)) {
					<thead>
						<tr>
							@if (selectable) {
								<th class="select"></th>
							}
							<ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
						</tr>
					</thead>
				}
				<tbody [ngClass]="mode === Mode.REARRANGE ? 'sortable-container' : ''">
					@if (autoCompleteTemplate && mode === Mode.ADD) {
						<tr class="add-item">
							<td class="relative" [attr.colspan]="tableColumns">
								<stages-auto-complete-search
									#autoComplete
									[focusOnInit]="true"
									[placeholder]="getSearchPlaceHolder() | translate"
									[query]="dataSource.newSearchQuery()"
									(submitted)="add($event)"
									(cancelled)="cancelAdd()"
									(focusLost)="cancelAdd()"
									[searchResultTemplate]="autoCompleteTemplate"
									[browseButtonActive]="browseItemButtonActive"
									(openBrowserButtonPressed)="openButtonPressed()"
									(closeButtonPressed)="closeButtonPressed()"
									class="relative"
								>
								</stages-auto-complete-search>
								@if (autoCompleteBrowseTemplate) {
									<p>
										<ng-container *ngTemplateOutlet="autoCompleteBrowseTemplate"></ng-container>
									</p>
								}
							</td>
						</tr>
					}
					@if (!autoCompleteTemplate && mode === Mode.ADD) {
						<tr class="add-item">
							<td class="relative" [attr.colspan]="tableColumns">
								<stages-add
									#addComponent
									[focusOnInit]="true"
									[placeholder]="getSearchPlaceHolder() | translate"
									[maxLength]="addMaxLength()"
									[pattern]="addPattern()"
									[patternMessageKey]="addPatternMessageKey()"
									(submitted)="add($event)"
									(focusLost)="cancelAdd()"
									(cancelled)="cancelAdd()"
									class="relative"
								>
								</stages-add>
							</td>
						</tr>
					}
					@for (item of data.items; track trackBy($index, item)) {
						<tr [ngClass]="getClasses(item)" [class.disabled]="inactiveFn()(item)">
							@if (selectable) {
								<td class="select">
									<input
										type="checkbox"
										class="checkbox"
										[id]="'select' + idFn(item)"
										[name]="'select' + idFn(item)"
										[checked]="
											(!idFnNew() && selection.isSelected(idFn(item))) ||
											(item
												| selectionStoreIsSelected
													: storeIdentifier()
													: isSelectAllActivated
													: triggerChangeCounter
													: idFnNew()
													: isPreselectedFn())
										"
										(change)="toggleSelection(item)"
										[disabled]="disabledFn()(item, data, mode)"
										[indeterminate]="
											item
												| selectionStoreIsPartiallySelected
													: storeIdentifier()
													: triggerChangeCounter
													: false
													: idFnNew()
										"
									/>
									<label [for]="'select' + idFn(item)"></label>
								</td>
							}
							<ng-container *ngTemplateOutlet="tableItemTemplate!; context: { $implicit: item }"></ng-container>
						</tr>
					}
				</tbody>
			</table>
			@if (data.page < data.totalPageCount && showMore()) {
				<footer>
					<ul class="list">
						<li class="list-item no-padding no-hover">
							<a class="label clickable" (click)="dataSource.loadMore()">
								<div class="avatar-cell-48"></div>
								<div class="text center">
									<span class="show-more" translate="more"></span>
								</div>
							</a>
						</li>
					</ul>
				</footer>
			}
		}
		@if (isSelectAllEnabled()) {
			<ul class="list">
				<li class="list-item">
					<ng-container *ngTemplateOutlet="selectAllTemplate"></ng-container>
				</li>
			</ul>
		}
		@if (!!translateNone && data.totalItemCount === 0 && (searchEngineAvailable || !hasActiveFilters())) {
			<ul class="list">
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: translateNone }"></ng-container>
			</ul>
		}
		@if (!searchEngineAvailable && hasActiveFilters()) {
			<ul class="list">
				<ng-container *ngTemplateOutlet="listInfoMessage; context: { $implicit: 'search.notavailable' }"></ng-container>
			</ul>
		}
	</ng-template>
	@if ((data.items.length > 0 || activeFilters.size > 0) && dataSource.filterEnabled()) {
		<form class="form">
			@if (filterTemplate) {
				<ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
			}
			@if (!filterTemplate) {
				<div class="input-container">
					<stages-rdv-text-filter
						[identifier]="'filterTerm'"
						[activeFilters]="activeFilters"
						[placeholder]="getFilterPlaceHolder()"
						(keyUpFired)="onFilterChange($event)"
					></stages-rdv-text-filter>
				</div>
			}
		</form>
	}
	@if (size$ | async; as size) {
		@if (listItemTemplate && tableItemTemplate) {
			@if (showListTemplate(size)) {
				<ng-container *ngTemplateOutlet="list" />
			} @else {
				<ng-container *ngTemplateOutlet="table" />
			}
		}
	}
	@if (listItemTemplate && !tableItemTemplate) {
		<ng-container *ngTemplateOutlet="list" />
	}
	@if (tableItemTemplate && !listItemTemplate) {
		<ng-container *ngTemplateOutlet="table" />
	}
	@if (data.totalPageCount > 1 && !showMore()) {
		<div class="list">
			<footer class="footer-pager">
				<stages-pager
					[pageSize]="data.pageSize ? data.pageSize : pageSize"
					[total]="data.totalItemCount"
					[page]="data.page"
					(goTo)="dataSource.goTo($event)"
				></stages-pager>
			</footer>
		</div>
	}
} @else {
	<stages-spin size="sm" />
}

<ng-template #selectAllTemplate>
	<span translate="select.all" class="h5 no-margin"></span>
	<input
		id="selectAll"
		type="checkbox"
		hidden="hidden"
		[checked]="isSelectAllActivated"
		(click)="selectDeselectAll()"
	/>
	<label for="selectAll" class="switch"></label>
</ng-template>

<ng-template #listInfoMessage let-context>
	<li class="list-item none">
		<div class="label">
			<p [translate]="context"></p>
		</div>
	</li>
</ng-template>

<ng-template #selectDeselectAllButtonTemplate>
	<stages-buttons-bottom [removeBoundaries]="true" [alignRight]="false" [isOnTop]="true" [addPadding]="true">
		<button class="button sm" translate="select.all" (click)="selectAll()"></button>
		<button class="button sm" translate="deselect.all" (click)="deselectAll()"></button>
	</stages-buttons-bottom>
</ng-template>
